import React from "react";
import { UiComponents} from "@simulanisindia/ui";
import Header from "./Header";
import Sidebar from "./Sidebar";

const ChildComponent = ({children}) => children;
const { MainLayout } = UiComponents;
const Private = ({ sideBar, setSideBar, children }) => {
  return (
    <>
      {/* <Header sideBar={sideBar} setSideBar={setSideBar} />
      <Sidebar sideBar={sideBar} setSideBar={setSideBar} />
      <div className={sideBar ? "main-content sideactive" : "main-content"}>{children}</div> */}
      <MainLayout Header={<Header />} SideBar={<Sidebar />} Component={<ChildComponent>{children}</ChildComponent>} />
    </>
  );
};

export default Private;
